var _rect, _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsiteBuilderPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 48,
    viewBox: "0 0 60 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 4.5,
    transform: "rotate(90 53.5 0.5)",
    fill: "#0CBFE7",
    stroke: "#0CBFE7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0753 12.0058C32.3483 12.0473 32.536 12.3023 32.4944 12.5753L28.9944 35.5753C28.9529 35.8483 28.6979 36.0359 28.4249 35.9944C28.1519 35.9528 27.9643 35.6978 28.0058 35.4248L31.5058 12.4248C31.5473 12.1518 31.8023 11.9642 32.0753 12.0058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8536 15.6464C25.0488 15.8417 25.0488 16.1583 24.8536 16.3536L17.2071 24L24.8536 31.6464C25.0488 31.8417 25.0488 32.1583 24.8536 32.3536C24.6583 32.5488 24.3417 32.5488 24.1464 32.3536L16.1464 24.3536C15.9512 24.1583 15.9512 23.8417 16.1464 23.6464L24.1464 15.6464C24.3417 15.4512 24.6583 15.4512 24.8536 15.6464Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1464 32.3536C34.9512 32.1583 34.9512 31.8417 35.1464 31.6464L42.7929 24L35.1464 16.3536C34.9512 16.1583 34.9512 15.8417 35.1464 15.6464C35.3417 15.4512 35.6583 15.4512 35.8536 15.6464L43.8536 23.6464C43.9473 23.7402 44 23.8674 44 24C44 24.1326 43.9473 24.2598 43.8536 24.3536L35.8536 32.3536C35.6583 32.5488 35.3417 32.5488 35.1464 32.3536Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 24C60 27.3137 57.3137 30 54 30C50.6863 30 48 27.3137 48 24C48 20.6863 50.6863 18 54 18C57.3137 18 60 20.6863 60 24Z",
    fill: "#9088DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 29C56.7614 29 59 26.7614 59 24C59 21.2386 56.7614 19 54 19C51.2386 19 49 21.2386 49 24C49 26.7614 51.2386 29 54 29ZM54 30C57.3137 30 60 27.3137 60 24C60 20.6863 57.3137 18 54 18C50.6863 18 48 20.6863 48 24C48 27.3137 50.6863 30 54 30Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C12 27.3137 9.31371 30 6 30C2.68629 30 0 27.3137 0 24C0 20.6863 2.68629 18 6 18C9.31371 18 12 20.6863 12 24Z",
    fill: "#9088DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 29C8.76142 29 11 26.7614 11 24C11 21.2386 8.76142 19 6 19C3.23858 19 1 21.2386 1 24C1 26.7614 3.23858 29 6 29ZM6 30C9.31371 30 12 27.3137 12 24C12 20.6863 9.31371 18 6 18C2.68629 18 0 20.6863 0 24C0 27.3137 2.68629 30 6 30Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(16 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteBuilderPreview);
export default __webpack_public_path__ + "static/media/WebsiteBuilderPreview.bec1740cfab5ba61a244ee33ed1abfdf.svg";
export { ForwardRef as ReactComponent };